import React from 'react';

import SubHeading from '../SubHeading/SubHeading';

import './Newsletter.css';

const Newsletter = () => (
  <div className='app__newsletter'>
    <div className='app__newsletter-heading'>
      <SubHeading title="Newsletter" />
      <h1 className='headtext__cormorant'>S'inscrire à notre newsletter</h1>
      <p className='p__opensans'>Et ne loupez jamais nos nouveautées !</p>
    </div>
    <div className='app__newsletter-input flex__center'>
      <input type="email" placeholder="Votre adresse email" />
      <button className='custom__button' onClick={() => alert('Ce site est une version de démonstration')}>S'abonner</button>
    </div>
  </div>
);

export default Newsletter;
